import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {Session} from "../../services/session.service";


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ContactUsComponent implements OnInit {

  lat: number = 5.57150;
  lng: number = -0.2051;

  constructor() { }

  ngOnInit() {
    Session.loggedIn = true;
    Session.loggedInObserver.next(true);
    Session.headerObserver.next(false);


  }

}



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/contact-us/contact-us.component.ts